import {
  bus
} from '@/event-bus.js'

export default {
  name: 'v-info-panel',
  data () {
    return {
      tutorial: false,
      disclaimer: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/v-acknowledgements.js